<template>
	<div class="ChannelConfig">
		<el-form :model="configForm" ref="form" label-width="160px" class="demo-ruleForm" :rules="rules">
			<el-form-item label="可配货日期" prop="available_delivery_date">
				<el-select v-model="configForm.available_delivery_date" placeholder="请选择可配货日期" multiple collapse-tags>
					<el-option :label="v.name" :value="v.id"
						v-for="(v,k) in appdata.list.available_delivery_date_config" :key="k"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="截止接单">
				<div class="timeselect">
					<div>
						<el-select v-model="configForm.stop_take_hour" placeholder="请选择时">
							<el-option :label="v" :value="v" v-for="(v,k) in appdata.list.stop_take_hour" :key="k"></el-option>
						</el-select>
						时
					</div>
					<div>
						<el-select v-model="configForm.stop_take_minute" placeholder="请选择分">
							<el-option :label="v" :value="v" v-for="(v,k) in appdata.list.stop_take_minute" :key="k">
							</el-option>
						</el-select>
						分
					</div>
				</div>
				<div class="ts">渠道将在这个时间点进行配货处理</div>
			</el-form-item>

			<el-form-item label="发货时间">
				<el-select v-model="configForm.delivery_time" placeholder="请选择发货时间">
					<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery_time" :key="k">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="免费退货比例">
				<el-select v-model="configForm.free_return_rate" placeholder="请选择发货时间">
					<el-option :label="v!=0? v+'%':v" :value="v" v-for="(v,k) in appdata.list.free_return_rate"
						:key="k">
					</el-option>
				</el-select>
				<div class="ts">0表示不允许，100表示无条件退货</div>
			</el-form-item>

			<el-form-item label="超比例扣费用">
				<el-select v-model="configForm.exceed_rate_deduct" placeholder="请选择发货时间">
					<el-option :label="v!=0? v+'%':v" :value="v" v-for="(v,k) in appdata.list.exceed_rate_deduct"
						:key="k">
					</el-option>
				</el-select>
				<div class="ts">注：免费退货比例为100时，“超比例扣费用”必须是0；免费退货比例为0，“超比例扣费用”必须大于0 （5折及以上，按吊牌比例扣款；5折以下的，扣款金额=折后金额*扣款比例*2）
				</div>
			</el-form-item>

			<el-form-item label="售后自动受理天数" prop="after_service_day_number">
				<el-input v-model.number="configForm.after_service_day_number" placeholder="请输入售后自动受理天数"></el-input>
				<div class="ts">7天无理由退货可以自动受理，其他原因不会自动受理。注：一般情况下，自动受理天数不能为0，比如：10,11,12；如果超比例扣费用为100%，则自动受理天数只能为0。</div>
			</el-form-item>

			<el-form-item label="退货收件人" prop="return_name">
				<el-input v-model="configForm.return_name" placeholder="请输入退货收件人"></el-input>
			</el-form-item>

			<el-form-item label="退货收件人手机号" prop="return_mobile">
				<el-input v-model.number="configForm.return_mobile" placeholder="请输入退货手机号"></el-input>
			</el-form-item>

			<el-form-item label="退货地址" prop="areaData">
				<el-cascader :props="props" v-model="configForm.areaData" :options="regionData"></el-cascader>
			</el-form-item>

			<el-form-item label="退货详细地址" prop="return_address">
				<el-input v-model="configForm.return_address" placeholder="请输入退货详细地址" type="textarea"
					:autosize="{ minRows: 2, maxRows: 4}"></el-input>
			</el-form-item>

			<el-form-item label="退货注意事项">
				<el-input v-model="configForm.return_notice" placeholder="请输入退货注意事项" type="textarea"
					:autosize="{ minRows: 2, maxRows: 4}"></el-input>
			</el-form-item>

			<el-form-item label="渠道手机号" prop="mobile">
				<el-input v-model.number="configForm.mobile" placeholder="请输入渠道手机号"></el-input>
			</el-form-item>

			<el-form-item label="渠道qq" prop="qq">
				<el-input v-model.number="configForm.qq" placeholder="请输入渠道QQ"></el-input>
				<div class="ts">备注：此QQ用于平台管理员或者平台客服联系渠道所用，且用于接受平台发送的各种通知信息，渠道可以自行修改QQ号！</div>
			</el-form-item>

			<el-form-item label="渠道发货省份" prop="channel_delivery_province">
				<el-select v-model="configForm.channel_delivery_province" placeholder="请选择省份">
					<el-option :label="v.label" :value="v.label" v-for="(v,k) in regionData" :key="k">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="渠道发货手机号后4位" prop="channel_delivery_mobile">
				<el-input v-model="configForm.channel_delivery_mobile" placeholder="请输入手机号后4位"></el-input>
				<div class="ts">备注：填写4位数字，多个用“，”隔开，用于识别顺丰物流记录用</div>
			</el-form-item>

			<el-form-item label="是否多仓发货">
				<el-switch v-model="configForm.multi_delivery_switch" :active-value="1" :inactive-value="0"></el-switch>
			</el-form-item>
			<el-form-item label="撕防伪设置" prop="security">
				<el-select v-model="configForm.security" placeholder="请选择撕防伪设置">
					<el-option :label="v.name" :value="v.id"
						v-for="(v,k) in appdata.list.discount_security" :key="k"></el-option>
				</el-select>
				<div class="ts">渠道下的产品会跟随这个设置</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		name: 'ChannelConfig',
		data() {
			return {
				configForm: {
					id: "",
					available_delivery_date: [],
					stop_take_hour: "",
					stop_take_minute: "",
					delivery_time: "",
					free_return_rate: "",
					exceed_rate_deduct: "",
					after_service_day_number: "",
					return_name: "",
					return_mobile: "",
					
					return_province: "",
					return_city: "",
					return_area: "",
					areaData: [],
					
					return_address: "",
					return_notice: "",
					mobile: "",
					qq: "",
					channel_delivery_province: "",
					channel_delivery_mobile: "",
					multi_delivery_switch: 0,
					security: 1,
				},

				rules: {
					return_mobile: [{
						required: true,
						message: '请输入退货收件人手机号',
						trigger: 'blur'
					}],

					mobile: [{
						required: true,
						message: '请输入渠道手机号',
						trigger: 'blur'
					}],
					
					qq: [{
						required: true,
						message: '请输入渠道qq',
						trigger: 'blur'
					}],
					
					available_delivery_date:[{
						required: true,
						message: '请选择可配货日期',
						trigger: 'blur'
					}],
					
					return_name:[{
						required: true,
						message: '请输入退货收件人',
						trigger: 'blur'
					}],
					
					areaData:[{
						required: true,
						message: '请选择退货地址',
						trigger: 'change'
					}],
					
					return_address: [{
						required: true,
						message: '请输入退货详细地址',
						trigger: 'blur'
					}],
					
					channel_delivery_province: [{
						required: true,
						message: '请选择渠道发货省份',
						trigger: 'change'
					}],
					
					channel_delivery_mobile: [{
						required: true,
						message: '请输入渠道发货手机号后4位',
						trigger: 'blur'
					}]
					
				},

				sheng: [],
				shi: [],
				qu: [],
				jiedao: [],
				id: 1,
				value: [],
				regionData: [],
				props: {
					value: 'label', 
					label: 'label',
					children: 'children'
				}
			}
		},

		inject: ['appdata'],

		props: {
			checkobj: {
				type: Object,
				default: {}
			},
		},

		mounted() {
			for (let key in this.configForm) {
				if (key != "available_delivery_date") {
					this.configForm[key] = this.checkobj[key];
				} else {
					if (this.checkobj[key]) {
						this.configForm[key] = this.checkobj[key].split(",").map(Number);
					}
				}
			}
			this.regionData = regionData;
			this.configForm.areaData = [];
			if(this.configForm.return_province && this.configForm.return_city && this.configForm.return_area) {
				this.configForm.areaData.push(this.configForm.return_province);
				this.configForm.areaData.push(this.configForm.return_city)
				this.configForm.areaData.push(this.configForm.return_area)
			}
			
		},

		updated() {
			// console.log(this.appdata.list);
		},

		methods: {
			onsubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.configForm));
						obj.available_delivery_date = obj.available_delivery_date.join(',');
						obj.return_province = obj.areaData[0];
						obj.return_city = obj.areaData[1];
						obj.return_area = obj.areaData[2];
						this.$emit('submit', obj);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.ChannelConfig {
		.el-input {
			width: 206px;
		}
		
		.el-cascader {
			width: 300px;
		}
		
		.el-textarea {
			width: 300px;
		}
	}

	.el-form-item {
		position: relative;

		.ts {
			position: absolute;
			height: 40px;
			left: 230px;
			top: 0;
			color: #ff4714;
			font-size: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: initial !important;
		}
	}
	
	.timeselect {
		width: 206px;
		display: flex;
		justify-content: space-between;
		>div {
			display: flex;
			align-items: center;
		}
		/deep/ .el-select {
			width: 74px !important;
			padding-right: 6px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/channelConfig.vue